var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noImage)?_c('img',{class:_vm.styles,attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('img',{class:_vm.styles,attrs:{"src":_vm.imageDefault,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }